import { cart } from '../components/cart'
import { input } from '../components/input'
import { checkbox } from '../components/checkbox'
import { select } from '../components/select'
import { progress } from '../components/progress'
import { modal } from '../components/modal'
import { button } from '../components/button'
import { success } from '../components/success'
import { footer } from '../components/footer'
import { header } from '../components/header'
import { form } from '../components/form'
import { upload } from '../components/upload'
import { termsModal } from '../components/termsModal'
import { confirmationModal } from '../components/confirmationModal'

export const components = {
  input,
  checkbox,
  select,
  progress,
  modal,
  button,
  cart,
  success,
  footer,
  header,
  form,
  upload,
  termsModal,
  confirmationModal
} 